module.exports = __webpack_public_path__ + "img/almenu_gomb_palyazatok_lezart_aktiv.890e101d.png";